import {
  IBaseTaskItemSession,
  ILessonTaskItemBase,
  ITaskSession
} from 'common/modules/ReactShared';

export function filterItemsBySessionItems<
  TaskItem extends ILessonTaskItemBase,
  SessionItem extends IBaseTaskItemSession
>(taskItems: TaskItem[], sessionTaskItems: SessionItem[]): TaskItem[] {
  const sessionItemsSetByItemId = new Set(
    sessionTaskItems.map((sessionTaskItem) => sessionTaskItem.taskItemId)
  );

  // show items that have item session
  const taskItemsIntersection = taskItems.filter((taskItem) =>
    sessionItemsSetByItemId.has(taskItem.id)
  );

  return taskItemsIntersection;
}

export function cleanSessionItemsByTaskItems<
  TaskItem extends ILessonTaskItemBase,
  SessionItem extends IBaseTaskItemSession
>(taskItems: TaskItem[], sessionTaskItems: SessionItem[]): SessionItem[] {
  const taskItemsSet = new Set(taskItems.map((taskItem) => taskItem.id));

  // order by items that comes in task
  const mappedIds = Array.from(taskItemsSet);

  // check if session items has its corresponding task items
  const sessionItemsIntersection = sessionTaskItems.filter((sessionTaskItem) =>
    taskItemsSet.has(sessionTaskItem.taskItemId)
  );

  const orderedItemsSessions = structuredClone(sessionItemsIntersection).sort(
    (a: SessionItem, b: SessionItem) => {
      return mappedIds.indexOf(a.taskItemId) - mappedIds.indexOf(b.taskItemId);
    }
  );

  return orderedItemsSessions;
}

// A `pending` session (started, nothing answered yet) is still playable.
export function isLessonCompleted(taskSession?: ITaskSession): boolean {
  const status = taskSession?.lessonSession.status;
  return status === 'completed' || status === 'canceled';
}
